import { bindable, autoinject } from 'aurelia-framework';
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import { AppEvents } from 'core/app-events';


@autoinject()
export class EditableWidget {
	

	@bindable save: Function;
	@bindable validate: Function;
	showEditContent = false;
	showEditIcon = true;
	showSaveIcon = false;
	//showIcons = false;
	edit() {
		this.showEditContent = true;
		this.showSaveIcon = true;
		this.showEditIcon = false;
	}
	saveEdit() {
		if (this.validate()) {
			this.showEditContent = false;
			this.showEditIcon = true;
			this.showSaveIcon = false;
			this.save();
		}
	}
}
